export default "__VITE_ASSET__CJ803E16__"